import { render, staticRenderFns } from "./Setting-modify-permission.vue?vue&type=template&id=b2152dd8&scoped=true"
import script from "./Setting-modify-permission.vue?vue&type=script&lang=js"
export * from "./Setting-modify-permission.vue?vue&type=script&lang=js"
import style0 from "./Setting-modify-permission.vue?vue&type=style&index=0&id=b2152dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2152dd8",
  null
  
)

export default component.exports